import React from 'react';
import DatasetCollectionRow from '../containers/DatasetCollectionRow';

const DatasetCollectionRows = ({
  category,
  code,
  collections,
  name,
}) => (
  collections.map((collection) => (
    <DatasetCollectionRow
      key={collection.code}
      category={category}
      code={code}
      collection={collection}
      name={name}
    />
  ))
);

export default DatasetCollectionRows;
